import { lazy } from "react";
import Loadable from "components/Loadable";
import YearList from "pages/standards/molecules/YearList";

// Lazy-loaded components
const Folder = Loadable(lazy(() => import("../../molecules/Folder")));
const List = Loadable(lazy(() => import("../../molecules/List")));
const Detail = Loadable(lazy(() => import("../../molecules/Detail")));
const AddEditFormat = Loadable(lazy(() => import("../AddEditFormat")));

const FormatStructureRoute = [
  {
    path: "format",
    children: [
      {
        path: "format-list",
        element: (
          <List
            moduleType="procedure"
            limit={30}
            name="Format"
            navigateUrl="format-list"
          />
        )
      },
      {
        path: "format-list/:id",
        element: (
          <List
            moduleType="format-by-parentId"
            limit={30}
            name="Format"
            navigateUrl="format-type"
          />
        )
      },
      {
        path: "format-type/:documentId",
        element: (
          <Folder
            moduleType="format"
            name="Format Folders"
            detailUrl="format-type"
            yearUrl="format-detail-year"
          />
        )
      },
      {
        path: "format-detail-year/:documentId/:type",
        element: (
          <YearList
            moduleType="format"
            name="Format Folders"
            detailUrl="format-type"
            yearUrl="format-detail-year"
            navigateUrl="format-type"
          />
        )
      },
      {
        path: "format-type/:documentId/:type?/:year?",
        element: <Detail moduleType="format" name="Format" />
      },
      {
        path: "format-type-detail/:mId/:type/:fId",
        element: <AddEditFormat moduleType="format" name="Format" />
      }
    ]
  }
];

export default FormatStructureRoute;
